import { Box, Spinner, Text } from '@chakra-ui/react'
import { FlexRow } from '@components'
import { useGetCurrentBreakpoint } from '@shared/hooks/use_get_current_breakpoint'
import { numberFormat } from '@shared/utils'
import { appColors } from '@theme/foundations/colors'
import { t } from 'i18next'
/* eslint-disable max-lines-per-function */
import type { FC } from 'react'
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import { getNiceTickValues } from 'recharts-scale'

interface WeekdaysGraphProps {
  graphData: any
}

export const WeekdaysGraph: FC<WeekdaysGraphProps> = ({ graphData }) => {
  const currentBreakpoint = useGetCurrentBreakpoint()

  const xAxisInterval = () => {
    switch (currentBreakpoint) {
      case 'xs':
        return 5
      case 'sm':
      case 'md':
      case 'lg':
        return 2
      default:
        return 4800
    }
  }

  let currentMax = 0
  let niceTickValues: any = []
  if (graphData) {
    currentMax = graphData[0].value
    niceTickValues = getNiceTickValues([graphData.at(-1).value, currentMax], 5, false)
  }

  return (
    <Box>
      {graphData ? (
        <Box>
          <FlexRow alignItems={'flex-start'} justifyContent={'space-between'}>
            <Text color='gray.400' fontSize={'10px'} marginBottom={4}>
              {`${t('dashboard.saving_statistics_card.average_consumption')} (kWh)`}
            </Text>
          </FlexRow>

          <ResponsiveContainer width={'100%'} height={250}>
            <BarChart data={graphData} margin={{ top: 16 }}>
              <XAxis
                xAxisId={1}
                dataKey={'day'}
                tickLine={false}
                tickMargin={8}
                axisLine={{ stroke: appColors.gray['300'] }}
                tick={{
                  fontSize: '10px',
                  fill: appColors.gray['400'],
                }}
              />
              <YAxis
                yAxisId={1}
                type='number'
                tickLine={false}
                axisLine={false}
                tickMargin={8}
                tick={{
                  fontSize: '10px',
                  fill: appColors.gray['400'],
                }}
                tickFormatter={value => numberFormat(value)}
              />

              <CartesianGrid vertical={false} stroke={'#F3F3F3'} />
              <Bar radius={[4, 4, 0, 0]} yAxisId={1} xAxisId={1} dataKey='value' fill={appColors.accentPrimary}>
                <LabelList dataKey='valueRounded' position={'top'} fill={appColors.accentPrimary} fontSize={'12px'} fontWeight={500} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={250}>
          <Spinner w={'64px'} h={'64px'}></Spinner>
        </Box>
      )}
    </Box>
  )
}
